import { Box, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import {
  PatientCounter,
  DateRangeFilter,
  AccountFilter,
  AssessmentFilter,
  ComparisonModeToggle,
  ExportButtons,
} from './components';
import useResponsiveLayout from './hooks/useResponsiveLayout';

const useStyles = makeStyles((theme) => ({
  controlPanel: {
    padding: theme.spacing(2.5),
    background: '#FFFFFF',
    borderRadius: 8,
    border: '1px solid #E6E9F0',
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    width: '100%',

    [theme.breakpoints.up('lg')]: {
      height: '100%',
      flexDirection: 'column',
    },
  },
  patientCountGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  spacer: {
    flex: '1 1 auto',
  },
}));

const ControlPanel = ({
  onExport,
  onExportChart,
  isPngExporting,
  isPdfExporting,
  isDataExporting,
}) => {
  const classes = useStyles();
  const isDistributionSponsor = useSelector((state) => state.user.isDistributionSponsor);
  const {
    isDesktop,
    shouldShowExportButtonsInTop,
    shouldShowExportButtonsInBottom,
    topRowStyle,
  } = useResponsiveLayout();

  return (
    <Box className={classes.controlPanel}>
      {/* Patient Count and Mobile Export Buttons */}
      <div className={classes.patientCountGroup}>
        {shouldShowExportButtonsInTop && (
          <ExportButtons
            onExport={onExport}
            onExportChart={onExportChart}
            showTitle={false}
            isPngExporting={isPngExporting}
            isPdfExporting={isPdfExporting}
            isDataExporting={isDataExporting}
          />
        )}
      </div>

      {/* Filter Controls */}
      {isDesktop ? (
        // Desktop layout - all filters in one column
        <div style={topRowStyle}>
          <DateRangeFilter style={{ width: 275 }} />

          {isDistributionSponsor && (
            <AccountFilter style={{ minWidth: 200 }} />
          )}

          <AssessmentFilter style={{ minWidth: 200 }} />

          <ComparisonModeToggle />
        </div>
      ) : (
        // Mobile/Tablet layout - two rows
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {/* First row - Date and Account (if DS) */}
          <div style={{
            display: 'flex',
            gap: '24px',
            alignItems: 'flex-start',
            justifyContent: 'flex-start'
          }}>
            <DateRangeFilter style={{ flex: '0 1 300px', maxWidth: '300px' }} />
            {isDistributionSponsor && (
              <AccountFilter style={{ flex: '0 1 300px', maxWidth: '300px' }} />
            )}
          </div>

          {/* Second row - Assessment and Comparison Mode */}
          <div style={{
            display: 'flex',
            gap: '24px',
            alignItems: 'flex-start',
            justifyContent: 'flex-start'
          }}>
            <AssessmentFilter style={{ flex: '0 1 300px', maxWidth: '300px' }} />
            <ComparisonModeToggle style={{ flex: '0 0 auto' }} />
          </div>
        </div>
      )}

      {/* Desktop Export Buttons */}
      {shouldShowExportButtonsInBottom && (
        <ExportButtons
          onExport={onExport}
          onExportChart={onExportChart}
          showTitle={true}
          isPngExporting={isPngExporting}
          isPdfExporting={isPdfExporting}
          isDataExporting={isDataExporting}
        />
      )}

      {/* Spacer for desktop layout */}
      <div className={classes.spacer} />
    </Box>
  );
};

export default ControlPanel;
